import { render, staticRenderFns } from "./FormControlProductOptionsProductTypeId.vue?vue&type=template&id=5ecfeb8b"
import script from "./FormControlProductOptionsProductTypeId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlProductOptionsProductTypeId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports